// Highlights every occurrence of `highlight` inside `text` (case-insensitive).
// Shared by the public FAQ and the dashboard help center search.
export function HighlightText({
  text,
  highlight,
}: {
  text: string;
  highlight: string;
}) {
  if (!highlight.trim()) return <>{text}</>;
  const regex = new RegExp(
    `(${highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi",
  );
  const parts = text.split(regex);
  return (
    <>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <span
            key={i}
            className="text-primary bg-primary/10 border border-primary/20 px-1 rounded-sm font-mono"
          >
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
}
